/*eslint no-unused-vars:0*/
'use strict';

const isMobileWidth = require('../../modules/util/isMobileWidth');
const isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth');
const isSmallView = require('../../modules/helpers/isSmallView');
const ScrollMagic = require('scrollmagic');
const controller = new ScrollMagic.Controller();

const $mainPdpBlock = $('.js-pdp-main');

// Boolean to check if we are viewing a Personalised Gifting PDP
const isPG = $mainPdpBlock.hasClass('giftset-pdp-main-container');
const isScrub = $('.js-pdp-scrub-slider').length > 0;

// Boolean to check if we are viewing a configurable product
const isConfigurable = $mainPdpBlock.hasClass('js-product-configurable');

// Boolean to check if a product should have animation on mobile
const noMobileAnimaiton = $mainPdpBlock.hasClass('js-no-mobile-animation');

// Animation elements definitions
const scrollMagicTriggerEl = '.js-scroll-magic-trigger';
const productImages = '.js-product-images';
const $imagesSlider = isPG ? $('.js-pg-pdp-image') : $('.js-pdp-images-slider');
const productDetailsContainer = '.js-product-details-container';
const ingredientsImages = '.js-product-ingredients-images';
const ingredientsSceneEl = '.js-ingredients-scene-element';
const $ingredientsDetailsBlock = isPG ? ($('.js-custom-giftset').length > 0 ? $('.js-custom-giftset') : $('.js-write-a-card-block')) : $('.js-product-ingredients-details');
const $ingredientsBlock = $('.js-product-ingredients-block');
const $bottomAnimationBlock = $('.js-bottom-animation-block');
const $pulsatingButton = $('.js-experience-pulsating-button');

/**
* Initialize the scenes for mobile animations
*/
function initHeroScenesMobile() {
    // Pin imageDrag until ingredients
    const imageDragStartOffset = 0;
    const imageDragOffset = ($(window).height() / 2) + imageDragStartOffset;


    let imageDragDuration;

    // Count with ingredients block for duration if it exists
    if ($ingredientsDetailsBlock.length > 0) { // only animate in mobile for ingredients block
        imageDragDuration = $ingredientsDetailsBlock.offset().top - ($(productImages).offset().top || 0) - ($imagesSlider.outerHeight() || 0) - imageDragStartOffset;
    } else {
        // Otherwise get next block and hide behind it
        $mainPdpBlock.addClass('no-ingredients');
        imageDragDuration = $mainPdpBlock.offset().top + $mainPdpBlock.outerHeight() - 50;

        // if there is no ingredients block, the opaque overlay only covers the main block
        $('.js-pdp-opaque-overlay').addClass('cover-main-block-only');
    }

    // scene that pins and drags the product main image
    const sceneImageDrag = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, imageDragDuration),
        offset: imageDragOffset
    })
        .setPin(productImages, {
            pushFollowers: false
        })
        .on('start', function(){
            // show only image - no promotion label or slider bar
            $(productImages).toggleClass('show-image-only');
            // make slider show first picture
            if (!isPG && $imagesSlider.hasClass('slick-initialized')) {
                $imagesSlider.slick('slickGoTo', 0);
            }
            // lock/unlock slider
            if ($imagesSlider.css('pointer-events') === 'none') {
                $imagesSlider.css('pointer-events', 'auto');
            } else {
                $imagesSlider.css('pointer-events', 'none');
            }
        })
        .addTo(controller);

    // Start opacity animation
    const opacityDurationOffset = isPG ? (isMobileWidth() ? 20 : -50) : 150;
    const opacityDuration = imageDragDuration - opacityDurationOffset;

    // Scene that activates the opaque layer behind the product description
    const sceneOpacity = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, opacityDuration),
        offset: imageDragOffset
    })
        .setClassToggle(productDetailsContainer, 'opaque')
        .addTo(controller);

    const blurOpacityDuration = isConfigurable ? 0 : imageDragDuration - opacityDurationOffset;

    // Scene controls blur animation of the main product image
    const sceneBlur = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, blurOpacityDuration),
        offset: imageDragOffset
    })
        .setClassToggle(productImages, 'blurred')
        .addTo(controller)
        .on('start', function(){
        // hide/show pulsating button
            if ($pulsatingButton.hasClass('hidden')){
                $pulsatingButton.removeClass('hidden');
            } else {
                $pulsatingButton.addClass('hidden');
            }
        });

    if ($ingredientsDetailsBlock.length) {

        // Show ingredients
        const ingredientsOffset = imageDragStartOffset + ($(productDetailsContainer).outerHeight() * 2 / 3); // offset + 2 thirds of the product details block
        const ingredientsDuration = $ingredientsDetailsBlock.offset().top + $ingredientsDetailsBlock.outerHeight() - ingredientsOffset;

        // Scene that controls show/hide of the ingredients images
        const sceneIngredients = new ScrollMagic.Scene({
            triggerElement: scrollMagicTriggerEl,
            duration: Math.max(0, ingredientsDuration),
            offset: ingredientsOffset
        });

        if ($(ingredientsImages).length){
            sceneIngredients.setClassToggle(ingredientsImages, 'show');
        }
        sceneIngredients.addTo(controller);
    }
}

/**
 * Prepared pulsating button elements
 */
function pulsatingButtonPosition() {
    if ($('.js-slider-bar').length > 0) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '62px'
            );
        } else {
            $pulsatingButton.css(
                'bottom', '80px'
            );
        }
    }

    if (($('.js-slider-bar').length == 0) && (($('.js-promotional-label').length == 0))) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '5px'
            );
        } else {
            $pulsatingButton.css(
                'bottom', '0px'
            );
        }
    }

    if (($('.js-promotional-label').length > 0)) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '90px'
            );
        }
    }
}

/**
* Initializes the desktop mode
*/
function initDesktop() {
    if (!isScrub && $bottomAnimationBlock.length > 0) {
        const ingredientsBlockExists = !isPG && $ingredientsBlock.length > 0;

        $(productImages).imagesLoaded(function() {
            initHeroScenesDesktop(ingredientsBlockExists);

            if (ingredientsBlockExists) {
                initIngredientScenesDesktop();
            }
        });
    }
}

/**
 * Initializes the ScrollMagic hero scenes for desktop
 *
 * @param {Boolean} isIngredientBlock Switch to determine which end block to
 * use for the scroll animation
 */
function initHeroScenesDesktop(isIngredientBlock) {
    const headerHeight = $('.js-header').height();
    let offset = getimageDragTop();

    const $blockForAnimation = isIngredientBlock ? $ingredientsBlock : $bottomAnimationBlock;

    // TODO: Remove after PG PDP fully developed
    const duration = getElementTop($blockForAnimation) + (getElementHeight($blockForAnimation) / 2) - (getElementHeight($(productImages)) / 2);

    // For larger screens where the offset falls before the trigger
    if (!isPG && offset < ($(productImages).height() + $(productImages).position().top)){
        offset = ($(window).height() / 2) - headerHeight + 40; // 40 px to allow the user to scroll a tiny bit
    }

    $imagesSlider.on('beforeChange', function(){
        // if animation has started, make slider go back to 1st image
        $(window).scroll(function() {
            // make slider show first picture
            if ($imagesSlider.slick('getSlick').slideCount > 1 &&
                $imagesSlider.slick('slickCurrentSlide') !== 0) {
                $imagesSlider.slick('slickGoTo', 0);
            }
        });
    });

    // Pin packshot until ingredients
    const sceneImageDrag = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: duration,
        offset: offset
    })
        .setPin(productImages, {
            pushFollowers: false
        })
        .on('start', function(){
            // Show only image - no promotion label or slider bar
            $(productImages).toggleClass('show-image-only');

            if (!isPG && $imagesSlider.hasClass('slick-initialized')) {
                // Make slider show first picture
                if ($imagesSlider.slick('getSlick').slideCount > 1 &&
                    $imagesSlider.slick('slickCurrentSlide') !== 0) {
                    $imagesSlider.slick('slickGoTo', 0);
                }

                // Lock / unlock slider
                if ($imagesSlider.css('pointer-events') === 'none') {
                    $imagesSlider.css('pointer-events', 'auto');
                } else {
                    $imagesSlider.css('pointer-events', 'none');
                }
            }
        })
        .addTo(controller);

    // Hide experience button a little bit after the hero pin happens
    const sceneExperienceButton = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: duration,
        offset: offset + 60
    })
        .on('start', function(){
            // Hide / show pulsating button
            if ($pulsatingButton.hasClass('hidden')){
                $pulsatingButton.removeClass('hidden');
            } else {
                $pulsatingButton.addClass('hidden');
            }
        })
        .addTo(controller);
}

/**
 * Initializes the ScrollMagic ingredients scenes for desktop
 */
function initIngredientScenesDesktop() {
    const offset = getElementTop($ingredientsBlock) + $(window).height() / 8;

    // Reveal ingredients
    const sceneRevealIngredients = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        offset: offset
    })
        .setClassToggle(ingredientsSceneEl, 'show')
        .addTo(controller);
}

/**
 * Prepare DOM elements for animations
 */
function getimageDragTop() {
    const headerHeight = $('.js-header').height();
    const mainImageHeight = isPG ? $(window).height() : $('.js-product-main-image').height();
    const productTop = $(productImages).position().top;

    return productTop + (mainImageHeight / 2) + (isPG ? -(headerHeight) : headerHeight);
}

/**
 * Calculates the top part of an element and returns it
 *
 * @param {String} el Selector of element
 * @returns {Integer} Calculated top of element
 */
function getElementTop(el) {
    const offset = -150;
    return $(el).offset().top + (isPG ? 0 : offset);
}

/**
 * Calculates the height of an element and returns is
 *
 * @param {String} el Selector of element
 * @returns {Integer} Calculated height of element
 */
function getElementHeight(el) {
    return $(el).height();
}

/**
* @description Prepare DOM elements for animations
*/
function prepareDOM() {
    // Show ingredient images - hidden on load to preserve page layout
    $(ingredientsImages).show();

    // Add class to PDP root element. Helps isolate animation styles
    if (!isScrub) {
        $('.js-pt-product-details').addClass('animate-scroll');
    }
}

const pdpAnimations = {
    init: function() {
        prepareDOM();

        if ($(scrollMagicTriggerEl).length > 0 && $mainPdpBlock.length) {
            if ((!isPG && !isScrub && !noMobileAnimaiton && isMobileWidth()) || (isPG && isMobileOrTabletWidth())) {
                initHeroScenesMobile();
            } else {
                if (document.readyState === 'complete') {
                    initDesktop();
                } else {
                    $(window).on('load', function () {
                        initDesktop();
                    });
                }
            }
        }

        // Init pulsating button position
        pulsatingButtonPosition();
    }
};

module.exports = pdpAnimations;
